var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Optional } from '@angular/core';
import { Store } from '@ngrx/store';
import { ExportDataLoaderService } from '@synisys/idm-dynamic-forms-controls';
import { ExportService } from '@synisys/idm-export-client-js';
import { Observable } from 'rxjs/Observable';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { first, map, switchMap } from 'rxjs/operators';
import { TemplateBuilderCommunicationService } from './template-builder-communication.service';
var ExpressionEvaluationService = /** @class */ (function () {
    function ExpressionEvaluationService(store, exportService, templateBuilderCommunicationService, exportDataLoaderService) {
        this.store = store;
        this.exportService = exportService;
        this.templateBuilderCommunicationService = templateBuilderCommunicationService;
        this.exportDataLoaderService = exportDataLoaderService;
    }
    ExpressionEvaluationService.prototype.getEvaluatedExpressionsValues = function (expressions
    // tslint:disable-next-line:no-any
    ) {
        var _this = this;
        return this.templateBuilderCommunicationService.getIdentity().pipe(first(), switchMap(function (_a) {
            var id = _a.id, categorySystemName = _a.category;
            return combineLatest(_this.exportDataLoaderService
                ? _this.exportDataLoaderService.getExportData(categorySystemName, id)
                : Observable.of({}), _this.store.select(function (state) { return state.languages.currentLanguageId; })).pipe(map(function (_a) {
                var data = _a[0], languageId = _a[1];
                return ({
                    data: data,
                    languageId: languageId,
                    id: id,
                    categorySystemName: categorySystemName,
                });
            }));
        }), first(), switchMap(function (_a) {
            var data = _a.data, languageId = _a.languageId, categoryItemId = _a.id, categorySystemName = _a.categorySystemName;
            return _this.exportService.evaluate({
                expressions: expressions,
                categorySystemName: categorySystemName,
                categoryItemId: categoryItemId,
                languageId: languageId,
                data: data,
                classifiersSystemNames: [],
                messageComponentIds: [],
                timeZoneId: Intl.DateTimeFormat().resolvedOptions()
                    .timeZone,
            });
        }));
    };
    ExpressionEvaluationService = __decorate([
        Injectable(),
        __param(3, Optional()),
        __metadata("design:paramtypes", [Store,
            ExportService,
            TemplateBuilderCommunicationService,
            ExportDataLoaderService])
    ], ExpressionEvaluationService);
    return ExpressionEvaluationService;
}());
export { ExpressionEvaluationService };
//# sourceMappingURL=expression-evaluation.service.js.map